import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M8.805 1.541a.75.75 0 0 1 .153.84 9.347 9.347 0 0 0-.83 3.862 9.384 9.384 0 0 0 9.385 9.384 9.348 9.348 0 0 0 3.862-.83.75.75 0 0 1 .993.993 10.886 10.886 0 0 1-9.922 6.404c-6.011 0-10.884-4.873-10.884-10.884 0-4.415 2.629-8.215 6.403-9.922a.75.75 0 0 1 .84.153ZM6.922 3.723a9.384 9.384 0 1 0 13.11 13.11 10.89 10.89 0 0 1-2.52.294c-6.01 0-10.883-4.873-10.883-10.884 0-.867.101-1.711.293-2.52Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  c
];
function l(d, s) {
  return e(), t("svg", n, [...r]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
